

























































































// @ts-ignore
import v8n from 'v8n';
import moment from 'moment';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import ReportOverview from '@/components/admin/ReportOverview.vue';
import ReportInout from '@/components/admin/ReportInout.vue';
import ReportExtras from '@/components/admin/ReportExtras.vue';
import { apiBase, apiNamespace } from '@/config';

@Component({
  components: { ReportInout },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;

  endDateRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .endDate()
        .test(v) || 'Date must be after the start date.',
  ];

  get reportComponent() {
    switch (this.$route.name) {
      case 'admin-reports':
        return ReportOverview;
      case 'admin-reports-inout':
        return ReportInout;
      case 'admin-reports-extras':
        return ReportExtras;
      default:
        return null;
    }
  }

  get startDate() {
    let date = moment()
      .subtract(6, 'months')
      .format('YYYY-MM-DD');

    if (
      this.$route.query.start_date &&
      typeof this.$route.query.start_date === 'string'
    ) {
      const isValid = moment(
        this.$route.query.start_date,
        'YYYY-MM-DD',
      ).isValid();
      if (isValid) {
        date = this.$route.query.start_date;
      }
    }

    return date;
  }

  set startDate(val) {
    if (!this.$route.name) {
      return;
    }

    if (val !== this.startDate) {
      this.$router.replace({
        name: this.$route.name,
        query: { start_date: val, end_date: this.endDate },
      });
    }
  }

  get endDate() {
    let date = moment().format('YYYY-MM-DD');

    if (
      this.$route.query.end_date &&
      typeof this.$route.query.end_date === 'string'
    ) {
      const isValid = moment(
        this.$route.query.end_date,
        'YYYY-MM-DD',
      ).isValid();
      if (isValid) {
        date = this.$route.query.end_date;
      }
    }

    return date;
  }

  set endDate(val) {
    if (!this.$route.name) {
      return;
    }

    if (val !== this.endDate) {
      this.$router.replace({
        name: this.$route.name,
        query: { start_date: this.startDate, end_date: val },
      });
    }
  }

  get formattedStartDate() {
    if (!this.startDate) {
      return '';
    }
    return moment(this.startDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  get formattedEndDate() {
    if (!this.endDate) {
      return '';
    }
    return moment(this.endDate, 'YYYY-MM-DD').format('D/M/YYYY');
  }

  get startDateISO() {
    if (!this.startDate) {
      return;
    }
    return moment(this.startDate, 'YYYY-MM-DD').toISOString();
  }

  get endDateISO() {
    if (!this.endDate) {
      return;
    }
    return moment(this.endDate, 'YYYY-MM-DD')
      .endOf('day')
      .toISOString();
  }

  get kpiSummary() {
    return apiBase + apiNamespace + '/kpi-summary-csv/?month=' + this.endDate;
  }

  beforeMount() {
    const endDate = () => {
      return (value: string) =>
        moment(value, 'D/MM/YYYY').diff(
          moment(this.startDate, 'YYYY-MM-DD'),
          'days',
        ) >= 0;
    };
    v8n.extend({ endDate });
  }
}
